import { SCAttributes } from "../generic/generic-sc-attributes";
import { SCKpis } from "../generic/generic-sc-domain";
import { ISCUser, RoleEnum } from "./salescredit-role-types";

interface IFieldMap {
  budget: string[];
  budgetProrate: string[];
}
export function IncludeBudget(
  userProfile: ISCUser,
  filters: { [attribute: string]: string[] }
): boolean {
  if (
    [
      RoleEnum.SALES,
      RoleEnum.MANAGER,
      RoleEnum.MANAGER_SALES_LIST,
      RoleEnum.MANAGER_SALES_TEAM,
      RoleEnum.MANAGER_SALES_TEAM_BU,
    ].indexOf(userProfile.Role) < 0
  ) {
    return false;
  }
  for (const key of Object.keys(filters)) {
    if (
      key === SCAttributes.SC_SALESBEN_TEAM ||
      key === SCAttributes.SC_SALESBEN_SALES ||
      key === "Date" ||
      key === SCAttributes.SC_MARK_STEP_GROUP
    ) {
      continue;
    }
    if (filters[key].length > 0) {
      return false;
    }
  }
  return true;
}

export function MapBudgetField(
  indicatorKpiValues: { [index: string]: number },
  fieldName: string
): number {
  let value = NaN;
  const fieldList = {
    budget: [
      SCKpis.SC_BUDGET_SALES,
      SCKpis.SC_BUDGET_Team,
      SCKpis.SC_BUDGET_PC,
      SCKpis.SC_BUDGET_SBU,
      SCKpis.SC_BUDGET_BU,
    ],
    budgetProrate: [
      SCKpis.SC_BUDGET_SALES_PRORATA,
      SCKpis.SC_BUDGET_Team_PRORATA,
      SCKpis.SC_BUDGET_PC_PRORATA,
      SCKpis.SC_BUDGET_SBU_PRORATA,
      SCKpis.SC_BUDGET_BU_PRORATA,
    ],
  } as IFieldMap;
  const fields =
    fieldName === "budget" ? fieldList.budget : fieldList.budgetProrate;
  fields.forEach((x: string) => {
    if (indicatorKpiValues.hasOwnProperty(x)) {
      value = indicatorKpiValues[x];
    }
  });
  return value;
}
